import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useAdminUnderwriteQuote } from "@portal/api/bond-request/admin";
import { FC } from "react";
import { Icon } from "../primitives";
import { Button } from "../ui/Button";
import { Spinner } from "../ui/Spinner";

type UpdateQuoteUnderwritingProps = {
	accountId: SuretyAccountId;
	quoteId: SuretyQuoteId;
	underwriting: Dtos.Admin.Quote.Underwriting | null | undefined;
};

export const UpdateQuoteUnderwriting: FC<UpdateQuoteUnderwritingProps> = ({
	accountId,
	quoteId,
	underwriting,
}) => {
	const { underwriteQuote, underwriteQuoteIsLoading } = useAdminUnderwriteQuote(accountId, quoteId);

	const isStale = underwriting?.stale ?? false;

	return (
		<div
			aria-hidden={!isStale}
			className="overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out"
			style={{
				maxHeight: isStale ? "36px" : "0px",
				opacity: isStale ? 1 : 0,
			}}
		>
			<div className="flex w-full h-[36px] items-center justify-center space-x-[24px] bg-surface-neutral shadow-md border-b border-b-bc-default">
				<span className="text-[13px] font-[500]">
					Updates were made to this Bond Request that may impact underwriting
				</span>
				<Button
					color="primary"
					filled
					onClick={() => underwriteQuote()}
					className="h-[24px] text-[12px]"
					disabled={underwriteQuoteIsLoading || !isStale}
				>
					<div className="flex items-center space-x-[8px]">
						{underwriteQuoteIsLoading ? (
							<>
								<Spinner
									containerClassName="w-4 h-4"
									spinnerClassName="w-4 h-4 border-[4px] border-bc-inverse border-t-transparent"
								/>
								<span>Running...</span>
							</>
						) : (
							<>
								<Icon type="arrow-path" color="inverse" size="micro" />
								<span>Run Model</span>
							</>
						)}
					</div>
				</Button>
			</div>
		</div>
	);
};
